import { render, staticRenderFns } from "./DrawerRemarkList.vue?vue&type=template&id=cae09ae4"
import script from "./DrawerRemarkList.vue?vue&type=script&lang=js"
export * from "./DrawerRemarkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports